
GP.GPMod('Chat.Apis', function(self) {
    var _conf, _data, _gui, _vchat, _util, _events,
        _info, _log, _warn, _error, _timers, _vent, _cometD;

    this.on('before:start', function() {
        var chat_module   = self.app.module("Chat");
        chat_module.apis = _apis;
    });

    self.init_module = function() {
        var chat_module   = self.app.module("Chat");

        _conf   = chat_module.conf;
        _data   = chat_module.data;
        _vchat  = chat_module.vchat;
        _gui    = chat_module.gui;
        _util   = chat_module.util;
        _events = chat_module.events;

        _vent  = self.vent;
        _info  = self.app.Util.info;
        _log   = self.app.Util.log;
        _warn  = self.app.Util.warn;
        _error = self.app.Util.error;
        _trace = self.app.Util.trace;

        _cometD = $.cometd;
        _timers = GP.Util.timers;
    };


    var _apis = {
        send_action: function(chat_action, chat_data, cb) {
            var api_data = {
                duid:     _data.duid,
                // chat_type: _data.vc.type,
                action:   chat_action
            };

            // merge chat_data object (if supplied) into api_data object to send with ajax call
            $.extend(api_data, chat_data || {});
            _log('send_action called... sending ajax call with: ',  api_data);

            var module = _data.ajax_module;
            if (api_data.hasOwnProperty('module')) {
                module = api_data.module;
                delete api_data.module;
            }

            // check url params for `server` or `s` and add to api_data if found
            const url_params = new URLSearchParams(window.location.search);
            const server     = url_params.get('server') ?? url_params.get('s') ?? null;

            if (server) {
                api_data.force_server = server;
            }

            self.api.json(module, {
                data: api_data
            }).done(function(json) {
                if (typeof json != 'undefined' && json) {
                    _info('api callback json: ', json);

                    if (json.success) {
                        // success
                        if (typeof cb === 'function') {
                            cb.apply(this, arguments);
                        }
                    } else if (json.error) {
                        // message rate limit hit
                        _gui.add_error_msg(json.error);
                    }
                }
            }).fail(function(){
                // log failure?
            });
        },
        close_purchase_ticket: function(e) {
            _vent.trigger('Modal:close');
        },
        purchase_ticket: function(e) {
            if ($("#vc-purchase-ticket-form input[name='purchase_credits']").val() == 1) {
                _vent.trigger('Page:redirect', self.app.Util.clean_url('members/billing/add_credits'));
            }

            var $action_btn = $('#vc-purchase-ticket-form .modal-action-btn'),
                post_data   = {
                    process: 1,
                    streamer_duid: $("#vc-purchase-ticket-form input[name='streamer_duid']").val()
                };


            self.api.json('videochat.purchase_ticket', {
                type: 'POST',
                data: post_data,
                beforeSend: function(xhr) {
                    $action_btn.prop("disabled", true);
                }
            })
            .done(function(json) {
                if (json && json.error) {
                    var err_msg = (json.error.length ? json.error.join('<br>') : json.error);
                    $('.js-vc-ticket-wrap .alert-danger')
                        .html(err_msg)
                        .removeClass('hide');
                } else if (json && json.success) {
                    $('.js-vc-ticket-wrap .alert-danger')
                        .addClass('hide');
                    $('.js-vc-ticket-wrap .alert-success')
                        .html('Ticket purchased!')
                        .removeClass('hide');

                    // update data object for videochat type/paid
                    _data.vc.type = 'TICKET';
                    _data.vc.ticket_info.ticket_paid = true;

                    _timers.clear(_conf.timer_check_stream);
                    _vchat.setup_viewer(true, true);

                    $("#video-ticket-notice").hide();
                    $('#video-player').removeClass('ticket-preview');

                    setTimeout(function() {
                        $action_btn.prop("disabled", false);
                        _vent.trigger('Modal:close');
                    }, 1500);
                }
            })
            .fail(function() {
                $action_btn.prop("disabled", false);

                $('.js-vc-ticket-wrap alert-danger')
                    .html('Error!')
                    .removeClass('hide');
            })
            .always(function() {
            });
        },
        add_ban: function(username) {
            self.api.json('videochat.mod_ban', {
                type: 'POST',
                data: {
                    process: 1,
                    action: 'add_ban',
                    username: username
                }
            });
        },
        del_ban: function(username) {
            self.api.json('videochat.mod_ban', {
                type: 'POST',
                data: {
                    process: 1,
                    action: 'del_ban',
                    username: username
                }
            });
        },
        check_videochat_access: function(func, ctx) {
            self.api.json('videochat.check', {
                type: 'GET',
                data: {duid: _data.vc.room_id}
            }).done(function(json) {
                _log('check_videochat_access done called. json: ', $.extend(true, {}, json));

                if (json) {
                    if (json.free_show) {
                        func.call(ctx, true, false);
                    } else if (json.vid_chat) {

                        if (json.vid_chat.type == 'TICKET') {
                            var ticket_info  = json.vid_chat.ticket_info,
                                show_started = !!ticket_info.ticket_started;

                            _data.vc.type = 'TICKET';
                            _data.vc.ticket_info = ticket_info;
                            _data.vc.ticket_info.ticket_paid = !!ticket_info.ticket_paid;
                            _data.vc.ticket_info.ticket_started = show_started;

                            func.call(ctx, true, true);
                        } else if (json.vid_chat.type == 'PPM') {
                            _data.vc.type = 'PPM';
                            _data.vc.private_room = true;

                            if (json.vid_chat.private_info) {
                                _data.vc.private_info = json.vid_chat.private_info;
                            }

                            func.call(ctx, true, false);
                        }
                    }
                }
            });
        },
        cancel_ticket_show: function(e) {
            self.api.json('videochat.mod_live', {
                type: 'POST',
                data: {
                    process: 1,
                    action: 'cancel_ticket'
                }
            });
        },
        stop_private: function(e) {
            var post_data = {
                process:   1,
                room_id:   _data.vc.room_id,
                action:    'stop_ppm'
            };

            self.api.json('videochat.mod_live', {
                type: 'POST',
                data: post_data
            });
        },
        confirm_private: function(e) {
            _log('confirm');
            var post_data = {
                process:   1,
                room_id:   _data.vc.room_id,
                action:    'confirm_private'
            };

            self.api.json('videochat.mod_live', {
                type: 'POST',
                data: post_data
            })
            .done(function(json) {
                if (json && json.error) {
                    var err_msg = (json.error.length ? json.error.join('<br>') : json.error);
                    $('.js-vc-ticket-wrap .alert-danger')
                        .html(err_msg)
                        .removeClass('hide');
                } else if (json && json.success) {
                    $('.js-vc-ticket-wrap .alert-danger')
                        .addClass('hide');
                    $('.js-vc-ticket-wrap .alert-success')
                        .html('Ticket show scheduled!')
                        .removeClass('hide');

                    _vent.trigger('Modal:close');

                    _data.vc.type = 'PPM';
                }
            })
            .fail(function() {
                $('.js-vc-ticket-wrap alert-danger')
                    .html('Error!')
                    .removeClass('hide');
            });
        },
        set_private_ppm: function(e) {

            var ppm_cost = parseInt($(this).val(), 10);

            if (ppm_cost < 0) {
                return;
            }

            var post_data = {
                process:   1,
                ppm_cost:   ppm_cost,
                action:    'set_private_ppm'
            };

            _info('api.set_private_ppm called. e: ', e);
            _info('api.set_private_ppm post_data: ', post_data);
            _trace();

            self.api.json('videochat.mod_live', {
                type: 'POST',
                data: post_data
            });

        },
        request_private: function(e) {
            _log('apis request private');
            var post_data = {
                process:   1,
                room_id:   _data.vc.room_id,
                action:    'request_private'
            };

            self.api.json('videochat.mod_live', {
                type: 'POST',
                data: post_data
            })
            .done(function(json) {
                if (json && json.error) {
                    var err_msg = json.error;
                    $('.js-vc-ticket-wrap .alert-danger')
                        .html(err_msg)
                        .removeClass('hide');
                } else if (json && json.success) {
                    $('.js-vc-ticket-wrap .alert-danger')
                        .addClass('hide');
                    $('.js-vc-ticket-wrap .alert-success')
                        .html('Private Request Sent!')
                        .removeClass('hide');

                    setTimeout(function() {
                        _vent.trigger('Modal:close');
                    }, 1500);

                    _data.vc.type = 'PPM';
                }
            })
            .fail(function() {
                $('.js-vc-ticket-wrap alert-danger')
                    .html('Error!')
                    .removeClass('hide');
            });

        },
        deny_private: function(e) {
           var post_data = {
                process:   1,
                room_id:   _data.vc.room_id,
                action:    'deny_private'
            };

            self.api.json('videochat.mod_live', {
                type: 'POST',
                data: post_data
            });
        },
        start_ppm: function(e) {
            _log('_api.start_ppm called');
            _data.vc.private_info.start_ppm_called = true;

            var post_data = {
                process: 1,
                action:  'start_ppm',
                room_id: _data.vc.room_id,
                watcher_duid: _data.vc.private_info.watcher_duid
            };

            self.api.json('videochat.mod_live', {
                type: 'POST',
                data: post_data
            })
            .done(function(json) {
                if (json && json.error) {
                    var err_msg = (json.error.length ? json.error.join('<br>') : json.error);
                    $('.js-vc-ticket-wrap .alert-danger')
                        .html(err_msg)
                        .removeClass('hide');
                } else if (json && json.success) {


                }
            })
            .fail(function() {
                $('.js-vc-ticket-wrap alert-danger')
                    .html('Error!')
                    .removeClass('hide');
            });
        },
        start_ticket: function(e) {
            var post_data = {
                process:   1,
                info:     $("#vc-ticket-form input[name='info']").val(),
                credits:   $("#vc-ticket-form select[name='credits']").val(),
                start_time:$("#vc-ticket-form select[name='start_time']").val(),
                action:    'start_ticket'
            };

            self.api.json('videochat.mod_live', {
                type: 'POST',
                data: post_data
            })
            .done(function(json) {
                if (json && json.error) {
                    var err_msg = (json.error.length ? json.error.join('<br>') : json.error);
                    $('.js-vc-ticket-wrap .alert-danger')
                        .html(err_msg)
                        .removeClass('hide');
                } else if (json && json.success) {
                    $('.js-vc-ticket-wrap .alert-danger')
                        .addClass('hide');
                    $('.js-vc-ticket-wrap .alert-success')
                        .html('Ticket show scheduled!')
                        .removeClass('hide');

                    setTimeout(function() {
                        _vent.trigger('Modal:close');
                    }, 1500);
                }
            })
            .fail(function() {
                $('.js-vc-ticket-wrap alert-danger')
                    .html('Error!')
                    .removeClass('hide');
            });
        },
        send_tip: function(amount, duid) {
            // console.trace('Chat.apis.send_tip called. amount: ', amount, ' duid: ', duid);
            var goal_set = _.isEmpty(_data.vc.tip_goal);
            $.post('/members/user/tip/', {
                'process' : 1,
                'vchat': 1,
                'duid' : duid,
                'goal_set' : goal_set,
                'tip_amount' : amount
            })
            .done(function(json) {
                if (json && json.success) {
                    _events.hide_tip_panel();
                } else {
                    _events.handlers.tip_error(json);
                }
            }).fail(function() {
                _events.handlers.tip_error();
            });
        },
        update_expire: function(id) {
            self.api.json('videochat.update_expire', {
                type: 'POST',
                data: {
                    duid: id
                }
            })
            .done(function(json) {
                // could do something on success/fail here
            });
        },
        get_goal_modal: function(edit) {
            var u = '/members/videochat/goals_modal/';
            if (edit) {
                u += '?edit=1';
            }
            _vent.trigger('Modal:open', {
                url: u
            }, null, _gui.videochat_goal_modal_opened);
        },
        update_goal_details: function(e) {
            e.preventDefault();

            var post_data = {
                process:  1,
                title:    $("#vc-goals-form input[name='title']").val(),
                credits:  $("#vc-goals-form input[name='credits']").val(),
                new_goal: true
            };

            var action = $(this).data('action');
            if (action && action == 'continue') {
                var data = $(this).data();
                if (data && data.title && data.credits) {
                    var obj = {
                        tip_goal: {
                            title:    data.title,
                            credits:  parseInt(data.credits, 10),
                            progress: parseInt(data.progress, 10)
                        },
                        updated_goal: true
                    };

                    _vchat.update_tip_goal(obj);
                    _vent.trigger('Modal:close');
                    return;
                }
            }


            self.api.json('videochat.mod_goal', {
                type: 'POST',
                data: post_data
            })
            .done(function(json) {
                if (json && json.error) {
                    var err_msg = (json.error.length ? json.error.join('<br>') : json.error);
                    $('.js-vc-goal-wrap .alert-danger')
                        .html(err_msg)
                        .removeClass('hide');
                } else if (json && json.success) {
                    $('.js-vc-goal-wrap .alert-danger')
                        .addClass('hide');
                    $('.js-vc-goal-wrap .alert-success')
                        .html('Goal updated successfully!')
                        .removeClass('hide');

                    setTimeout(function() {
                        _vent.trigger('Modal:close');
                    }, 1500);
                }
            })
            .fail(function() {
                $('.js-vc-goal-wrap alert-danger')
                    .html('Error!')
                    .removeClass('hide');
            });
        },
        remove_goal: function() {
            self.api.json('videochat.mod_goal', {
                type: 'POST',
                data: {
                    process:     1,
                    remove_goal: true
                }
            }).always(function() {
                _vent.trigger('Modal:close');
            });
        },
        get_stream_preview_pic: function(user_duid, ctx, cb) {
            _trace('apis.get_stream_preview_pic called with user_duid: ', user_duid, ' ctx: ', ctx, ' cb: ', cb);

            var cb_ctx = (ctx || this); // callback context for this

            self.api.json('videochat.get_preview', {
                type: 'GET',
                data: {duid: user_duid}
            }).done(function(json) {
                _info('videochat.get_preview response... json: ', json);

                if (typeof cb == 'function' && json && json.preview_pic) {
                    cb.call(cb_ctx, json.preview_pic);
                } else {
                    cb.call(cb_ctx, null);
                }
            }).fail(function() {
                cb.call(cb_ctx, null);
            });
        }
    };

});

